/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_SubmitInputs */

const en_cp_form_submit = /** @type {(inputs: Cp_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send application`)
};

const id_cp_form_submit = /** @type {(inputs: Cp_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim pengajuan`)
};

/**
* | output |
* | --- |
* | "Send application" |
*
* @param {Cp_Form_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_submit = /** @type {((inputs?: Cp_Form_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_submit(inputs)
	return en_cp_form_submit(inputs)
});